import { Inject, Injectable, InjectionToken } from '@angular/core';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError, TimeoutError } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { MsToastService } from '../../../shared/services/ms-toast/ms-toast.services';
import { MsDialogDynamicService } from '../../../shared/services/ms-dialog-dynamic/ms-dialog-dynamic.services';
import { MsDialogErrorComponent } from '../../../shared/components/ms-dialog-error/ms-dialog-error.component';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
	constructor(
		@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number,
		private _msToastService: MsToastService,
		private _msDialogDynamicService: MsDialogDynamicService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const reqUrl = req.url;
		const reqApiCode = req.headers.get('x-request-api-code') || '-999';
		const modified = req.clone({
			setHeaders: { 'X-Request-Timeout': `${this.defaultTimeout}` },
		});
		const timeoutValue = Number(req.headers.get('timeout') || this.defaultTimeout);
		return next.handle(modified).pipe(
			timeout(timeoutValue),
			catchError((error) => {
				let isError = true;
				let _title: string = '';
				let _message: string = '';

				if (error instanceof HttpErrorResponse) {
					console.log(error.url);
					if (error.status === 401 && error.url) {
						isError = false;
					}
					_title = 'Requisição';
					_message = 'Falha ao processar a requisição.';
				} else if (error instanceof TimeoutError) {
					_title = 'Requisição';
					_message = 'Tempo limite excedido durante a execução da requisição.';
				} else {
					_title = 'Requisição';
					if (error instanceof Object) {
						_message = error.name;
					} else {
						_message = 'Não foi possível processar a requisição';
					}
				}
				if (isError) {
					this._msToastService.error({
						title: `${_title} (${reqApiCode})`,
						message: `${_message}`,
					});
					this._msDialogDynamicService.show('Deu erro fatal ...', error, MsDialogErrorComponent);
				}
				return throwError(() => error);
			})
		);
	}
}
